import request from '@/utils/request'


// 查询顺骋活动列表
export function listCarActive(query) {
  return request({
    url: '/carActive/carActive/list',
    method: 'get',
    params: query
  })
}

// 查询顺骋活动分页
export function pageCarActive(query) {
  return request({
    url: '/carActive/carActive/page',
    method: 'get',
    params: query
  })
}

// 查询顺骋活动详细
export function getCarActive(data) {
  return request({
    url: '/carActive/carActive/detail',
    method: 'get',
    params: data
  })
}

// 新增顺骋活动
export function addCarActive(data) {
  return request({
    url: '/carActive/carActive/add',
    method: 'post',
    data: data
  })
}

// 修改顺骋活动
export function updateCarActive(data) {
  return request({
    url: '/carActive/carActive/edit',
    method: 'post',
    data: data
  })
}

// 删除顺骋活动
export function delCarActive(data) {
  return request({
    url: '/carActive/carActive/delete',
    method: 'post',
    data: data
  })
}
